import AppUtils from "../../utils";

let dateFormat = (date) => {
  // 日期 年-月-日
  return AppUtils.formatDate(date);
};
let dateFormatToSecond = (date) => {
  //日期  年-月-日 时：分： 秒
  return AppUtils.formatDateToSecond(date);
};
let distributeStatusFilter = (state) => {
  if (state == null) {
    state = 3;
  }
  //工单状态
  const status = {
    0: "未分配",
    1: "已分配",
    2: "已处理",
    3: "已取消",
  };
  return status[state];
};
let classifyFilter = (state) => {
  //工单状态
  const status = {
    1: "图文报警",
    2: "视频报警",
    3: "122报警",
    4: "自行创建",
  };
  return status[state];
};
let callStatusFilter = (state) => {
  //工单状态
  const status = {
    0: "新建未操作",
    1: "暂存",
    2: "中途完成",
    3: "处置终止",
    4: "全流程完成",
    5: "挪车",
    7: "自行修改",
    8: "自行修改审核通过",
    9: "关闭",
    10: "报批修改",
    11: "报批修改完成",
  };
  return status[state];
};
let siteFilter = (state) => {
  //工单状态
  const status = {
    0: "离开",
    1: "空闲",
    2: "等待接听",
    3: "正在接听",
  };
  return status[state];
};

// 距离单位 km
let distanceUnit = (distance) => {
  if (distance) {
    return (distance / 1000).toFixed(3) + " km";
  }
  return "0km";
};

//价格
let priceUnit = (price) => {
  if (price || price === 0) {
    return price + " 元";
  }
};
//分钟
let minuteUnit = (minute) => {
  if (minute || minute === 0) {
    return minute + "分钟";
  }
};
//秒
let secondUnit = (second) => {
  if (second || second === 0) {
    return second + "秒";
  }
};
let claimFilter = (state) => {
  //工单状态
  const status = {
    0: "待理赔",
    1: "已理赔",
  };
  return status[state];
};
let solveFilter = (state) => {
  //工单状态
  const status = {
    2: "中途处置完成",
    4: "全流程处置完成",
  };
  return status[state];
};

let weatherFilter = (state) => {
  const status = {
    1: "晴",
    2: "阴",
    3: "雨",
    4: "雪",
    5: "雾",
    6: "大风",
    7: "沙尘",
    8: "冰雹",
    9: "霾",
    10: "多云",
    19: "其他",
  };
  return status[state];
};
let usePartFilter = (state) => {
  const status = {
    12: "侧前方",
    13: "侧后方",
    14: "碰撞部位",
    15: "侧方照片",
    16: "己方驾驶证",
    17: "己方行驶证",
    18: "对方驾驶证",
    19: "对方行驶证",
    20: "其他",
  };
  return status[state] || "其他";
};
// responList: [{
//     id: 1,
//     name: '全部责任'
// },
// {
//     id: 2,
//     name: '主要责任'
// },
// {
//     id: 3,
//     name: '同等责任'
// },
// {
//     id: 4,
//     name: '次要责任'
// },
// {
//     id: 5,
//     name: '无责任'
// },
// ],
let responListFilter = (state) => {
  const status = {
    1: "全部责任",
    2: "主要责任",
    3: "同等责任",
    4: "次要责任",
    5: "无责任",
  };
  return status[state];
};
let reportStatus = (state) => {
  if (state == -1) {
    state = 2;
  }
  const status = {
    2: "未操作",
    0: "拒绝",
    1: "受理",
  };
  return status[state];
};
let orderListFilter = (state) => {
  const status = {
    1: "小程序新建未处理",
    2: "暂存",
    3: "全流程完成",
    4: "处置终止",
    5: "手动取消",
    6: "超时取消",
    7: "PC新建未处理",
  };
  return status[state];
};
export {
  classifyFilter,
  reportStatus,
  responListFilter,
  distributeStatusFilter,
  weatherFilter,
  dateFormat,
  dateFormatToSecond,
  callStatusFilter,
  distanceUnit,
  priceUnit,
  minuteUnit,
  secondUnit,
  siteFilter,
  claimFilter,
  solveFilter,
  usePartFilter,
  orderListFilter,
};



// WEBPACK FOOTER //
// ./src/assets/js/filter.js